import React from "react";
import { useAppTranslation } from "../../../../../../../../../../../../../../i18n/useAppTranslation";
import { Row } from "../../../../../../../../shared/Row";
import styles from "./styles.module.scss";

export function Image({ displayLabels, label, url, multiSelect }) {
  const { tDashboard } = useAppTranslation.Dashboard();
  const { tCommon } = useAppTranslation.Common();

  return (
    <div className={styles.root}>
      <img src={url} alt={label} width="200px" />
      <Row label={tDashboard("user_logs_diff.questionnaires.label")}>
        {label}
      </Row>
      <Row label={tDashboard("user_logs_diff.questionnaires.display_labels")}>
        {displayLabels ? tCommon("label.yes") : tCommon("label.no")}
      </Row>
      <Row label={tDashboard("user_logs_diff.questionnaires.multi_select")}>
        {multiSelect ? tCommon("label.yes") : tCommon("label.no")}
      </Row>
    </div>
  );
}
